<template>
  <div id="ads" class="animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader class="hide">
      </WebshopHeader>
      <div class="py4 px3">
        <div class="pt2"></div>
        <h4 class="darkblue bold">Dine facebook annoner</h4>
        <a href="#/webshop/google-ads" class="gibson h5 primarycolor right">Se google annoncer</a>
        <div class="py3">
          <div class="p0">
            <el-tabs type="card" @tab-click="tabChanged">
              <el-tab-pane label="Nuværende"></el-tab-pane>
              <el-tab-pane label="Gamle"></el-tab-pane>
            </el-tabs>
            <div class="right-align" v-if="adsMsg == '' && !insideLoading">
              <el-pagination
                small
                layout="prev, pager, next"
                :total="parseInt(lastPage)" @current-change="paginationChanged" :current-page="parseInt(curPage)">
              </el-pagination>
            </div>
            <div class="clearfix" v-if="insideLoading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div v-else>
              <div class="pb2"></div>
              <div class="col-12 p0 lg-flex flex-wrap" v-if="adsMsg == ''">
                <div class="lg-col-4 md-col-12 p0 pr3 mb4" v-for="(ads,index) in adsData" :key="index">
                  <div class="border muted-border">
                    <div class="p2">
                      <div>
                        <div class="flex justify-between mb3 border-bottom muted-border">
                          <div class="block pb2">
                            <div>
                              <span class="h5 darkblue bold block">{{ads.AdId}}</span>
                            </div>
                            <div>
                              <span class="h6">Start dato: <span class="darkblue bold">{{moment(new Date(parseInt(ads.StartDate.substring(6).replace(")/", ""))).toLocaleDateString()).format('YYYY-MM-DD')}}</span></span>
                            </div>
                            <div>
                              <span class="fontsize15">{{ads.AdStatus}}</span>
                            </div>
                          </div>
                          <div class="pb2">
                            <div>
                              <a class="pointer no-hover" title="Løb" @click="statusChanged(ads.AdId, 'running')" v-if="ads.AdStatus == 'PAUSED' || ads.AdStatus == 'ARCHIVED'"><i class="el-icon-video-play h4"></i></a>
                              <a class="pointer no-hover" title="Pause" @click="statusChanged(ads.AdId, 'paused')" v-if="ads.AdStatus == 'ACTIVE'"><i class="el-icon-video-pause h4"></i></a>
                            </div>
                            <em class="green fontsize15">Afslutter {{moment(new Date(parseInt(ads.EndDate.substring(6).replace(")/", ""))).toLocaleDateString()).format('YYYY-MM-DD')}}</em>
                          </div>
                        </div>
                        <el-collapse class="border-none mb3">
                          <el-collapse-item :title="ads.AdName" name="index">
                            <div class="flex justify-between">
                              <div class="col-6 block pb2 pl0 pr0">
                                <div>
                                  <p class="gibson mediumgrey break-word">{{ads.AdDescription}}</p>
                                </div>
                              </div>
                              <div class="col-6 pb2 pl0 pr0 right-align">
                                <img :src="ads.ImageURL" width="90%">
                              </div>
                            </div>
                          </el-collapse-item>
                        </el-collapse>
                        <!-- <div class="flex justify-between pt3 border-top muted-border mb3">
                          <div class="col-4 p0">
                            <div>
                              <span class="h5 darkblue bold block">{{ads.Reach}}</span>
                            </div>
                            <div>
                              <span class="h6">Nå</span>
                            </div>
                          </div>
                          <div class="col-4 p0">
                            <div>
                              <span class="h5 darkblue bold block">{{ads.Clicks}}</span>
                            </div>
                            <div>
                              <span class="h6">Klik</span>
                            </div>
                          </div>
                          <div class="col-4 p0">
                            <div>
                              <span class="h5 darkblue bold block">{{ads.AmountSpent}}</span>
                            </div>
                            <div>
                              <span class="h6">Brugt resterende {{ads.BudgetRemaining}}</span>
                            </div>
                          </div>
                        </div> -->
                        <div>
                          <button :id="'btnId'+ads.AdId" type="button" class="gibson action-button py2 px3 h5 semi-bold not-rounded" @click="sendStatistic(ads.AdId)">
                            <span>Klik her for statistik</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt3"><span class="bold">{{adsMsg}}</span></div>
            </div>
            <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
export default {
  name: '',
  components: {
    WebshopHeader
  },
  data () {
    return {
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      adsData: [],
      filterStatus: 'active',
      adsMsg: 'Du har ingen annoncer.',
      curPage: 1,
      lastPage: 10
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.displayAds()
  },
  methods: {
    displayAds () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'integration/GetAdsbySupplierId/' + this.haaId + '/' + this.filterStatus + '/' + this.curPage + '/10'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res !== null && res.data.length >= 0) {
            var dataRes = res.data
            var pagLastPage = res.data[0].LastPage + '0'
            this.adsData = dataRes
            this.lastPage = pagLastPage
            if (!dataRes.length) {
              if (this.filterStatus === 'active') {
                this.adsMsg = 'Du Har Ingen Aktive Ads.'
              } else {
                this.adsMsg = 'Du Har Ingen Gammel Ads.'
              }
            } else {
              this.adsMsg = ''
            }
            this.insideLoading = false
          } else {
            this.insideLoading = false
            this.adsMsg = 'Der er sket en fejl.'
            this.$toastr('error', 'Fejl')
            console.log('Error in displayAds()', response)
          }
        },
        (response) => {
          this.insideLoading = false
          this.adsMsg = 'Der er sket en fejl.'
          this.$toastr('error', 'Fejl')
          console.log('Error in displayAds()', response)
        }
      )
    },
    statusChanged (id, status) {
      var data = {
      }
      this.$http.post('https://www.kundematch.dk/crm/libraries/productform/product.php?mode=checkinvoice&addsid=' + id, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          // If paid
          if (res.result.paid) {
            this.stopStartAd(id, status)
          } else {
            // If not
            this.insideLoading = false
            this.$toastr('error', 'Skal først betale')
          }
        },
        (response) => {
          console.log('Error in validatePayment')
          this.insideLoading = false
        }
      )
      this.insideLoading = true
    },
    stopStartAd (adId, status) {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        // url: 'integration/StopFBAd?Adid=' + adId
        url: 'integration/PauseFbAd/' + adId
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.displayAds()
            if (status === 'running') {
              this.$toastr('success', 'Løb')
            } else {
              this.$toastr('success', 'Pauset')
            }
          } else {
            this.insideLoading = false
            this.$toastr('error', 'Fejl')
            console.log('Error in stopStartAd()', response)
          }
        },
        (response) => {
          console.log('Error in stopStartAd()', response)
          this.insideLoading = false
        }
      )
    },
    tabChanged (tab) {
      if (tab.index === '0') {
        this.filterStatus = 'active'
      } else {
        this.filterStatus = 'old'
      }
      this.curPage = 1
      this.displayAds()
      this.insideLoading = true
    },
    paginationChanged (val) {
      var pagCurPage = (`${val}`)
      this.curPage = pagCurPage
      this.displayAds()
      this.insideLoading = true
    },
    sendStatistic (adId) {
      var data = {
        operation: 'adsstat',
        adstype: 'facebook',
        adsid: adId,
        salesPerson: this.salesPerson,
        type: 'POST'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
          } else {
            this.$toastr('error', 'Fejl')
            console.log('Error in sendStatistic()', response)
          }
        },
        (response) => {
          console.log('Error in sendStatistic()', response)
          this.insideLoading = false
        }
      )
      document.querySelector('#btnId' + adId).classList.add('invisible')
      let obj = {
        title: 'Vi sender en email til dig indenfor få dage',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj)
    }
  }
}
</script>
<style>
  #ads .status-buttons a:hover:after {
    display: none;
  }
  #ads .el-collapse-item .el-collapse-item__header {
    font-size: 1.25rem;
    line-height: 1.5rem;
    font-weight: bold;
    border: none;
    color: #003645;
    margin-bottom: 1rem;
  }
  #ads .el-collapse-item__content {
    font-size: 1rem; 
  }
  #ads .el-collapse-item .el-collapse-item__wrap {
    border-bottom: none;
  }
  @media (max-width: 64em) {
    #ads .col-12.flex > div.lg-col-4 {
      padding-right: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// FbAds.vue?5c4e5398